import pie from "pistacja/plugin";

// Enable onBlur inputs validation with regexp using "data-validate" attribute.
pie.plugin(function Contact({ $$ }) {
  $$("input[data-validate], textarea[data-validate]").forEach((input) => {
    input.addEventListener("blur", (event) => {
      if (new RegExp(input.dataset.validate).test(event.target.value)) {
        input.classList.remove("invalid");
        input.setCustomValidity("");
      } else {
        input.setCustomValidity("invalid");
        input.classList.add("invalid");
      }
    });
  });
});